import { CJEDTEvent } from '@teetsh/app/src/types/event';
import { Slice } from '@teetsh/app/src/types/print';
import { getMaxSliceForEvents } from '@teetsh/app/src/utils/slices';
import isWithinInterval from '@teetsh/app/src/utils/time/isWithinInterval';
import isEqual from '@teetsh/app/src/utils/time/isEqual';
import isBefore from '@teetsh/app/src/utils/time/isBefore';
import isAfter from '@teetsh/app/src/utils/time/isAfter';
import _uniqBy from 'lodash-es/uniqBy';

function isIntersecting(startA: Date, endA: Date, startB: Date, endB: Date) {
  if (
    isWithinInterval(
      startA,
      {
        start: startB,
        end: endB,
      },
      true,
    )
  ) {
    return true;
  }
  if (
    isWithinInterval(
      endA,
      {
        start: startB,
        end: endB,
      },
      true,
    )
  ) {
    return true;
  }
  return (
    (isBefore(startA, startB) || isEqual(startA, startB)) &&
    (isAfter(endA, endB) || isEqual(endA, endB))
  );
}

export function getRelatedEvents(
  event: CJEDTEvent,
  events: CJEDTEvent[],
): CJEDTEvent[] {
  function getRelatedEventsRec(
    evt: CJEDTEvent,
    evts: CJEDTEvent[],
    relatedEvents: CJEDTEvent[],
    visitedEvents: any,
  ): { relatedEvents: CJEDTEvent[]; visitedEvents: any } {
    visitedEvents[evt.id] = true;
    const notVisitedEvents = evts.filter(e => !visitedEvents[e.id]);
    if (notVisitedEvents.length === 0) {
      return { relatedEvents, visitedEvents };
    }
    return notVisitedEvents.reduce(
      (acc, num) => {
        if (isEqual(num.start, evt.start) && isEqual(num.end, evt.end)) {
          acc.visitedEvents[num.id] = true;
          return {
            relatedEvents: [...acc.relatedEvents, num],
            visitedEvents: acc.visitedEvents,
          };
        }
        if (!isIntersecting(num.start, num.end, evt.start, evt.end)) {
          return acc;
        }
        return getRelatedEventsRec(
          num,
          notVisitedEvents,
          [...acc.relatedEvents, num],
          acc.visitedEvents,
        );
      },
      { relatedEvents, visitedEvents },
    );
  }

  const res = getRelatedEventsRec(event, events, [], {});
  return _uniqBy(res.relatedEvents, 'id');
}

// Bon... le nom de la fonction n'est pas ouf mais j'ai pas trouvé mieux sur le moment
// C'est pour récupérer les slices par groupe d'events
// Un groupe d'event c'est un ensemble event qui se chevauchent strictement ex: ev1 8h-10h, ev2 9h-11h
// ev1 8h-9h et ev2 9h-10h ne sont pas dans le même groupe
// ça va service pour récupérer le lcm pour que les colspan soient corrects
export default function getDistinctSlices(events: CJEDTEvent[]): Slice[] {
  const { slices } = events.reduce<{ slices: Slice[]; visitedEvents: any }>(
    (acc, event) => {
      if (!acc.visitedEvents[event.id]) {
        acc.visitedEvents[event.id] = true;
        const relatedEvents = getRelatedEvents(event, events);
        const groupedEvents = [event, ...relatedEvents];
        const newSlice = getMaxSliceForEvents(groupedEvents);
        groupedEvents.forEach(e => {
          acc.visitedEvents[e.id] = true;
        });
        return {
          slices: [...acc.slices, newSlice],
          visitedEvents: acc.visitedEvents,
        };
      }
      return acc;
    },
    { slices: [], visitedEvents: {} },
  );

  return slices;
}
